import React from 'react';
import { Link } from 'react-router-dom';
import Discord from '../../assets/icons/alias/discrod.svg';
import Email from '../../assets/icons/alias/email.svg';
import Name from '../../assets/icons/alias/name.svg';
import Opensea from '../../assets/icons/alias/opensea.svg';
import Telegram from '../../assets/icons/alias/telegram.svg';
import Twitter from '../../assets/icons/alias/twitter.svg';
import TruncatedText from '../../components/base/TruncatedText';
import Tooltip from '../../components/ui/Tooltip';
import uniqueId from '../../utils/uniqueId';
import ContactReach from './ContactReach';
import styles from './Contacts.module.scss';

export const getAliasIcon = (type) => {
  switch (type) {
    case 'email':
      return <Email />;
    case 'name':
      return <Name />;
    case 'twitter_id':
      return <Twitter />;
    case 'discord_id':
      return <Discord />;
    case 'telegram_id':
      return <Telegram />;
    case 'marketplace_name':
      return <Opensea />;
    default:
      break;
  }
};

const Contact = ({ data }) => {
  const tooltipId = uniqueId('alias');

  return (
    <div className={styles.contact_wrapper}>
      <Link
        className={styles.alias_link}
        to={`/profile/${data.id}`}
        data-for={tooltipId}
        data-tip
      >
        <TruncatedText text={data.alias} noTooltip />
      </Link>
      <Tooltip
        id={tooltipId}
        info={
          <div className={styles.tooltip}>
            <span>{getAliasIcon(data.alias_type)}</span>
            <span className={styles.alias}>{data.alias}</span>
          </div>
        }
      />
      <div className={styles.icons}>
        {data.address && <ContactReach data={data.address} type="wallet" />}
        {data.email && <ContactReach data={data.email} type="email" />}
        {data.phone && <ContactReach data={data.phone} type="phone" />}
        {data.twitter_id && (
          <ContactReach data={data.twitter_id} type="twitter" />
        )}
        {data.telegram_id && (
          <ContactReach data={data.telegram_id} type="telegram" />
        )}
        {data.discord_id && (
          <ContactReach data={data.twitter_id} type="discord" />
        )}
      </div>
    </div>
  );
};

export default Contact;
